package com.shadowings.gero.data.lessons.chapter13

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.shadowings.gero.data.lessons.chapter12.getTorniamoAllaGrammaticaQuizContent
import com.shadowings.gero.data.repository.DatabaseRepositoryImpl
import com.shadowings.gero.data.repository.SentenceOptions
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.Option
import com.shadowings.gero.domain.model.SingleSelectionContent
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Verb
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_le_preposizioni_1
import gero.composeapp.generated.resources.exp_content_le_preposizioni_10
import gero.composeapp.generated.resources.exp_content_le_preposizioni_11
import gero.composeapp.generated.resources.exp_content_le_preposizioni_12
import gero.composeapp.generated.resources.exp_content_le_preposizioni_13
import gero.composeapp.generated.resources.exp_content_le_preposizioni_14
import gero.composeapp.generated.resources.exp_content_le_preposizioni_15
import gero.composeapp.generated.resources.exp_content_le_preposizioni_16
import gero.composeapp.generated.resources.exp_content_le_preposizioni_17
import gero.composeapp.generated.resources.exp_content_le_preposizioni_18
import gero.composeapp.generated.resources.exp_content_le_preposizioni_19
import gero.composeapp.generated.resources.exp_content_le_preposizioni_2
import gero.composeapp.generated.resources.exp_content_le_preposizioni_20
import gero.composeapp.generated.resources.exp_content_le_preposizioni_21
import gero.composeapp.generated.resources.exp_content_le_preposizioni_22
import gero.composeapp.generated.resources.exp_content_le_preposizioni_23
import gero.composeapp.generated.resources.exp_content_le_preposizioni_3
import gero.composeapp.generated.resources.exp_content_le_preposizioni_4
import gero.composeapp.generated.resources.exp_content_le_preposizioni_5
import gero.composeapp.generated.resources.exp_content_le_preposizioni_6
import gero.composeapp.generated.resources.exp_content_le_preposizioni_7
import gero.composeapp.generated.resources.exp_content_le_preposizioni_8
import gero.composeapp.generated.resources.exp_content_le_preposizioni_9
import gero.composeapp.generated.resources.exp_title_le_preposizioni
import gero.composeapp.generated.resources.quiz_le_preposizioni_1
import gero.composeapp.generated.resources.quiz_le_preposizioni_1_opt1
import gero.composeapp.generated.resources.quiz_le_preposizioni_1_opt2
import gero.composeapp.generated.resources.quiz_le_preposizioni_1_opt3
import gero.composeapp.generated.resources.quiz_le_preposizioni_1_opt4
import gero.composeapp.generated.resources.quiz_le_preposizioni_2
import gero.composeapp.generated.resources.quiz_le_preposizioni_2_opt1
import gero.composeapp.generated.resources.quiz_le_preposizioni_2_opt2
import gero.composeapp.generated.resources.quiz_le_preposizioni_2_opt3
import gero.composeapp.generated.resources.quiz_le_preposizioni_2_opt4
import gero.composeapp.generated.resources.quiz_le_preposizioni_3
import gero.composeapp.generated.resources.quiz_le_preposizioni_3_opt1
import gero.composeapp.generated.resources.quiz_le_preposizioni_3_opt2
import gero.composeapp.generated.resources.quiz_le_preposizioni_3_opt3
import gero.composeapp.generated.resources.quiz_le_preposizioni_3_opt4
import kotlin.random.Random

// Amenemhat's own gardiner spelling (M17-Y5:N35-G17-F4h2:X1, see words.tsv) gives
// us a real name to point at for 'subject + m-complement, verb "to be" implied' -
// the same construction chapter 9's frasi_avverbiali/preposizione_m lessons taught,
// just recognized here in a name Nilo already showed off in chapter 4.
private const val AMENEMHAT_GARDINER = "M17-Y5:N35-G17-F4h2:X1"

fun getLePreposizioniContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_le_preposizioni,
            content = Res.string.exp_content_le_preposizioni_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_preposizioni,
            content = Res.string.exp_content_le_preposizioni_2,
            face = Faces.Idle,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_preposizioni,
            content = Res.string.exp_content_le_preposizioni_3,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_preposizioni,
            content = Res.string.exp_content_le_preposizioni_4,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_preposizioni,
            content = Res.string.exp_content_le_preposizioni_5,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_preposizioni,
            content = Res.string.exp_content_le_preposizioni_6,
            face = Faces.Happy,
            character = Characters.Nilo,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = AMENEMHAT_GARDINER,
                        rtl = false,
                        cart = false,
                        size = 96.dp
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_preposizioni,
            content = Res.string.exp_content_le_preposizioni_7,
            face = Faces.Surprised,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_preposizioni,
            content = Res.string.exp_content_le_preposizioni_8,
            face = Faces.Doubt,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_preposizioni,
            content = Res.string.exp_content_le_preposizioni_9,
            face = Faces.Happy,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_preposizioni,
            content = Res.string.exp_content_le_preposizioni_10,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_preposizioni,
            content = Res.string.exp_content_le_preposizioni_11,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_preposizioni,
            content = Res.string.exp_content_le_preposizioni_12,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_preposizioni,
            content = Res.string.exp_content_le_preposizioni_13,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_preposizioni,
            content = Res.string.exp_content_le_preposizioni_14,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_preposizioni,
            content = Res.string.exp_content_le_preposizioni_15,
            face = Faces.Happy,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_preposizioni,
            content = Res.string.exp_content_le_preposizioni_16,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_preposizioni,
            content = Res.string.exp_content_le_preposizioni_17,
            face = Faces.Sad,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_preposizioni,
            content = Res.string.exp_content_le_preposizioni_18,
            face = Faces.Idle,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_preposizioni,
            content = Res.string.exp_content_le_preposizioni_19,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_preposizioni,
            content = Res.string.exp_content_le_preposizioni_20,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_preposizioni,
            content = Res.string.exp_content_le_preposizioni_21,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_preposizioni,
            content = Res.string.exp_content_le_preposizioni_22,
            face = Faces.Serious,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_le_preposizioni,
            content = Res.string.exp_content_le_preposizioni_23,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
    )
}

fun getLePreposizioniQuizContent(
    verbs: List<Verb>,
    words: List<Word>,
    languageCode: String,
    random: Random = Random,
    verbSentences: List<SentenceOptions> = DatabaseRepositoryImpl.verbSentences
): List<IQuizContent> {
    val specificQuizzes: List<IQuizContent> = listOf(
        SingleSelectionContent(
            text = Res.string.quiz_le_preposizioni_1,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_le_preposizioni_1_opt1, correct = true),
                Option(Res.string.quiz_le_preposizioni_1_opt2, correct = false),
                Option(Res.string.quiz_le_preposizioni_1_opt3, correct = false),
                Option(Res.string.quiz_le_preposizioni_1_opt4, correct = false)
            ).shuffled(random)
        ),
        SingleSelectionContent(
            text = Res.string.quiz_le_preposizioni_2,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_le_preposizioni_2_opt1, correct = true),
                Option(Res.string.quiz_le_preposizioni_2_opt2, correct = false),
                Option(Res.string.quiz_le_preposizioni_2_opt3, correct = false),
                Option(Res.string.quiz_le_preposizioni_2_opt4, correct = false)
            ).shuffled(random)
        ),
        SingleSelectionContent(
            text = Res.string.quiz_le_preposizioni_3,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_le_preposizioni_3_opt1, correct = true),
                Option(Res.string.quiz_le_preposizioni_3_opt2, correct = false),
                Option(Res.string.quiz_le_preposizioni_3_opt3, correct = false),
                Option(Res.string.quiz_le_preposizioni_3_opt4, correct = false)
            ).shuffled(random)
        )
    )

    val reviewQuizzes = getTorniamoAllaGrammaticaQuizContent(
        verbs = verbs,
        words = words,
        languageCode = languageCode,
        random = random,
        verbSentences = verbSentences
    ).take(7)

    return specificQuizzes + reviewQuizzes
}
